
<div [ngSwitch]="getSite()">

       <!-- DEFAULT -->
        <div *ngSwitchDefault id="comment-ca-marche" class="row justify-content-center">
          
          <h1 class="col-12 clem-font autopartage text-center">
            <b>{{ 'AUTOPARTAGE.MARCHE.TITLE' | translate }}</b>
          </h1>

          <div class="col-11 col-md-10">

            <div class="row justify-content-center">

              <!-- 1 -->
              <div class="col-3 col-md-3">
                <div class="text-center">
                  <img class="img-fluid" src="../../../assets/img/Autopartage/Avantages/PictoAutopartage_Inscription.svg">
                  <h4>{{ 'AUTOPARTAGE.MARCHE.PARA1' | translate }}</h4>
                </div>
              </div>

              <!-- 2 -->
              <div class="col-3 col-md-3">
                <div class="text-center">
                  <img class="img-fluid" src="../../../assets/img/Autopartage/CCM/PictoAutopartage_Reservation.svg">
                  <h4>{{ 'AUTOPARTAGE.MARCHE.PARA2' | translate }}</h4>
                </div>
              </div>

              <!-- 3 -->
              <div class="col-3 col-md-3">
                <div class="text-center">
                  <img class="img-fluid" src="../../../assets/img/Autopartage/CCM/PictoAutopartage_BorneResa.svg">
                  <h4>{{ 'AUTOPARTAGE.MARCHE.PARA3' | translate }}</h4>
                </div>
              </div>

              <!-- 4 -->
              <div class="col-3 col-md-3">
                <div class="text-center">
                  <img class="img-fluid" src="../../../assets/img/Autopartage/CCM/PictoAutopartage_Clef.svg">
                  <h4>{{ 'AUTOPARTAGE.MARCHE.PARA4' | translate }}</h4>
                </div>
              </div>

              <!-- 5 -->
              <div class="col-3 col-md-3">
                <div class="text-center">
                  <img class="img-fluid" src="../../../assets/img/Autopartage/CCM/PictoAutopartage_EtatVoiture.svg">
                  <h4>{{ 'AUTOPARTAGE.MARCHE.PARA5' | translate }}</h4>
                </div>
              </div>

              <!-- 6 -->
              <div class="col-3 col-md-3">
                <div class="text-center">
                  <img class="img-fluid" src="../../../assets/img/Autopartage/CCM/PictoAutopartage_Trajet.svg">
                  <h4>{{ 'AUTOPARTAGE.MARCHE.PARA6' | translate }}</h4>
                </div>
              </div>

              <!-- 7 -->
              <div class="col-3 col-md-3">
                <div class="text-center">
                  <img class="img-fluid" src="../../../assets/img/Autopartage/CCM/PictoAutopartage_StationVoiture.svg">
                  <h4>{{ 'AUTOPARTAGE.MARCHE.PARA7' | translate }}</h4>
                </div>
              </div>

              <!-- 8 -->
              <div class="col-3 col-md-3">
                <div class="text-center">
                  <img class="img-fluid" src="../../../assets/img/Autopartage/CCM/PictoAutopartage_ChargeVoitureClef.svg">
                  <h4>{{ 'AUTOPARTAGE.MARCHE.PARA8' | translate }}</h4>
                </div>
              </div>

            </div>

          </div>
        </div>

      <!-- mam sncf -->
      <div *ngSwitchCase="'mam'" id="comment-ca-marche" class="row justify-content-center"  >
        <h1 class="col-12  titleBookk"><b>{{ 'AUTOPARTAGE.MARCHE.TITLE' | translate }}</b></h1>
        <div   class="col-12 col-md-10">
          <div class="row justify-content-center step-1">
            <div class="col-8 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">
                  <img class="img-fluid" src="../../../assets/img/MamSncf/ccm/PictoAutopartage_Inscription-01.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA1' | translate }}
                </h4>
              </div>
            </div>
            <div class="col-8 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">
                  <img class="img-fluid" src="../../../assets/img/MamSncf/ccm/PictoAutopartage_Reservation-01.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA2' | translate }}
                </h4>
              </div>

            </div>
            <div class="col-8 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">

                  <img class="img-fluid"
                    src="../../../assets/img/MamSncf/ccm/PictoAutopartage_BorneResa-01.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA3' | translate }}
                </h4>
              </div>
            </div>
            <div class="col-8 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">

                  <img class="img-fluid"
                    src="../../../assets/img/MamSncf/ccm/PictoAutopartage_Clef.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA4' | translate }}
                </h4>
              </div>
            </div>
          </div>
          <div class="row justify-content-around step-2">
            <div class="col-8 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">

                  <img class="img-fluid"
                    src="../../../assets/img/MamSncf/ccm/PictoAutopartage_EtatVoiture-01.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA5' | translate }}
                </h4>

              </div>
            </div>
            <div class="col-8 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">

                  <img class="img-fluid"
                    src="../../../assets/img/MamSncf/ccm/PictoAutopartage_Trajet-01.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA6' | translate }}
                </h4>
              </div>

            </div>
            <div class="col-8 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">

                  <img class="img-fluid"
                    src="../../../assets/img/MamSncf/ccm/PictoAutopartage_StationVoiture-01.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA7' | translate }}
                </h4>
              </div>
            </div>
            <div class="col-8 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">

                  <img class="img-fluid"
                    src="../../../assets/img/MamSncf/ccm/PictoAutopartage_ChargeVoitureClef-01.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA8' | translate }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Remi -->
      <div *ngSwitchCase="'remi'" id="comment-ca-marche" class="row justify-content-center"  >
        <h1 class="col-12  titleBookk"><b>{{ 'AUTOPARTAGE.MARCHE.TITLE' | translate }}</b></h1>
        <div   class="col-12 col-md-10">
          <div class="row justify-content-center">

            <div class="col-3 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">
                  <img class="img-fluid" src="../../../assets/img/Remi/svg/1.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA1' | translate }}
                </h4>
              </div>
            </div>
            <div class="col-3 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">
                  <img class="img-fluid" src="../../../assets/img/Remi/svg/2.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA2' | translate }}
                </h4>
              </div>

            </div>
            <div class="col-3 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">

                  <img class="img-fluid"
                    src="../../../assets/img/Remi/svg/3.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA3' | translate }}
                </h4>
              </div>
            </div>
            <div class="col-3 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">

                  <img class="img-fluid"
                    src="../../../assets/img/Remi/svg/4.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA4' | translate }}
                </h4>
              </div>
            </div>
          </div>

          <div class="row mt-4 justify-content-around">
            <div class="col-3 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">

                  <img class="img-fluid"
                    src="../../../assets/img/Remi/svg/55.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA5' | translate }}
                </h4>

              </div>
            </div>
            <div class="col-3 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">

                  <img class="img-fluid"
                    src="../../../assets/img/Remi/svg/6.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA6' | translate }}
                </h4>
              </div>

            </div>
       
            <div class="col-3 col-md-3">
              <div class="row">
                <div class="col-12" style="
                  text-align: center;
              ">

                  <img class="img-fluid"
                    src="../../../assets/img/Remi/svg/8a.svg" alt="">
                </div>
                <h4 class="col-12">
                  {{ 'AUTOPARTAGE.MARCHE.PARA8' | translate }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>


</div>